import { AUTHKEY_AKE_FINAL, AUTHKEY_AKE_FINISH, AUTHKEY_AKE_RESPONSE, AUTHKEY_START_AKE, PARTICIPANT_VERIFIED, SET_E2EE_ENABLE_ON_CREDENTIAL_READY, SET_E2EE_ROOM_OWNER, SET_MAX_MODE, SET_MEDIA_ENCRYPTION_KEY, START_VERIFICATION, TOGGLE_E2EE } from './actionTypes';
/**
 * Dispatches an action to enable / disable E2EE.
 *
 * @param {boolean} enabled - Whether E2EE is to be enabled or not.
 * @returns {Object}
 */
export function toggleE2EE(enabled) {
    return {
        type: TOGGLE_E2EE,
        enabled
    };
}
/**
 * Dispatches an action to set E2EE maxMode.
 *
 * @param {string} maxMode - The new value.
 * @returns {Object}
 */
export function setE2EEMaxMode(maxMode) {
    return {
        type: SET_MAX_MODE,
        maxMode
    };
}
/**
 * Records whether E2EE should be enabled after AuthKey credentials are completed.
 *
 * @param {boolean} enabled - Whether the pending enable flow is active.
 * @returns {Object}
 */
export function setE2EEEnableOnCredentialReady(enabled) {
    return {
        type: SET_E2EE_ENABLE_ON_CREDENTIAL_READY,
        enabled
    };
}
/**
 * Records the participant allowed to enable AuthKey E2EE for this conference.
 *
 * @param {string|undefined} ownerId - Participant id of the room owner.
 * @param {Object} [options] - Options for the room owner update.
 * @param {boolean} [options.broadcast] - When false, do not send MUC command.
 * @returns {Object}
 */
export function setE2EERoomOwner(ownerId, options) {
    return {
        type: SET_E2EE_ROOM_OWNER,
        ownerId,
        broadcast: options?.broadcast
    };
}
/**
 * Dispatches an action to set media encryption key.
 *
 * @param {Object} keyInfo - Json containing key information.
 * @param {string} [keyInfo.encryptionKey] - The exported encryption key.
 * @param {number} [keyInfo.index] - The index of the encryption key.
 * @returns {{
 *     type: SET_MEDIA_ENCRYPTION_KEY,
 *     keyInfo: Object
 * }}
 */
export function setMediaEncryptionKey(keyInfo) {
    return {
        type: SET_MEDIA_ENCRYPTION_KEY,
        keyInfo
    };
}
/**
 * Dispatches an action to start participant e2ee verification process.
 *
 * @param {string} pId - The participant id.
 * @returns {{
 *     type: START_VERIFICATION,
 *     pId: string
 * }}
 */
export function startVerification(pId) {
    return {
        type: START_VERIFICATION,
        pId
    };
}
/**
 * Dispatches an action to set participant e2ee verification status.
 *
 * @param {string} pId - The participant id.
 * @param {boolean} isVerified - The verification status.
 * @returns {{
 *     type: PARTICIPANT_VERIFIED,
 *     pId: string,
 *     isVerified: boolean
 * }}
 */
export function participantVerified(pId, isVerified) {
    return {
        type: PARTICIPANT_VERIFIED,
        pId,
        isVerified
    };
}
export function startAuthKeyAKE(pId) {
    return {
        type: AUTHKEY_START_AKE,
        pId
    };
}
export function sendAKEResponseMessage(pId, akeMessage) {
    return {
        type: AUTHKEY_AKE_RESPONSE,
        pId,
        akeMessage
    };
}
export function sendAKEFinalMessage(pId, akeMessage) {
    return {
        type: AUTHKEY_AKE_FINAL,
        pId,
        akeMessage
    };
}
export function finishAuthKeyAKE(pId, akeMessage) {
    return {
        type: AUTHKEY_AKE_FINISH,
        pId,
        akeMessage
    };
}
